export default __webpack_public_path__ + "static/media/seg-0-artist.b28c6aa6.png";